<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange" show-all="N"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card v-if="aShopDataInfo.shopId">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('aShop.shopInfo') }}</span>
          </div>

          <!-- 业主信息 -->
          <div class="margin-top">
            <el-row>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.shopName') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.shopName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.shopType') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.shopTypeName || '-' }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.merchantName') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.storeName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.merchantAddress') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.storeAddress || '-' }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    退货电话：
                  </label>
                  <label class="">{{ aShopDataInfo.returnLink || '-' }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.shopStatus') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.stateName || '-' }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t('aShop.createTime') }}：
                  </label>
                  <label class="">{{ aShopDataInfo.createTime || '-' }}</label>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="vc-line-primary margin-top"></div>
          <div class="margin-top-sm">
            <el-tabs v-model="aShopDataInfo._currentTab" @tab-click="changeTab(aShopDataInfo._currentTab)">
              <el-tab-pane label="商品" name="aShopDetailProduct" v-if="aShopDataInfo.shopTypeCate=='1' || aShopDataInfo.shopTypeCate=='2'"></el-tab-pane>
              <el-tab-pane label="商品分组" name="aShopDetailCategory" v-if="aShopDataInfo.shopTypeCate=='1' || aShopDataInfo.shopTypeCate=='2'"></el-tab-pane>
              <el-tab-pane label="仓库" name="aShopDetailHouse" v-if="aShopDataInfo.shopTypeCate=='1' || aShopDataInfo.shopTypeCate=='2'"></el-tab-pane>
              <el-tab-pane label="便民服务" name="aShopDetailServ" v-if="aShopDataInfo.shopTypeCate=='3'"></el-tab-pane>
<!--              <el-tab-pane label="入库记录" name="aShopDetailInstock"></el-tab-pane>-->
<!--              <el-tab-pane label="出库记录" name="aShopDetailOutstock"></el-tab-pane>-->
<!--              <el-tab-pane label="会员" name="aShopDetailVip"></el-tab-pane>-->
              <el-tab-pane label="订单" name="aShopDetailOrder"></el-tab-pane>
              <el-tab-pane label="退货" name="aShopDetailRefundOrder"></el-tab-pane>
<!--              <el-tab-pane label="拼团商品" name="aShopDetailGroup"></el-tab-pane>-->
<!--              <el-tab-pane label="拼团订单" name="aShopDetailGroupOrders"></el-tab-pane>-->
<!--              <el-tab-pane label="拼团退单" name="aShopDetailRefundGOrders"></el-tab-pane>-->
              <el-tab-pane label="秒杀商品" name="aShopDetailSeckill" v-if="aShopDataInfo.shopTypeCate=='1' || aShopDataInfo.shopTypeCate=='2'"></el-tab-pane>
              <el-tab-pane label="秒杀订单" name="aShopDetailSeckillOrders" v-if="aShopDataInfo.shopTypeCate=='1' || aShopDataInfo.shopTypeCate=='2'"></el-tab-pane>
            </el-tabs>
          </div>
          <div>
            <component :is="aShopDataInfo._currentTab" :ref="aShopDataInfo._currentTab"></component>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import AdminShop from '@/components/shop/adminShop'
import AShopDetailProduct from '@/components/goods/aShopDetailProduct'
import AShopDetailCategory from '@/components/shop/aShopDetailCategory'
import AShopDetailHouse from '@/components/shop/aShopDetailHouse'
import AShopDetailServ from '@/components/housekeeping/aShopDetailServ'
import AShopDetailInstock from '@/components/goods/aShopDetailInstock'
import AShopDetailOutstock from '@/components/goods/aShopDetailOutstock'
import AShopDetailVip from '@/components/user/aShopDetailVip'
import AShopDetailOrder from '@/components/order/aShopDetailOrder'
import AShopDetailRefundOrder from '@/components/order/aShopDetailRefundOrder'
import AShopDetailGroup from '@/components/group/aShopDetailGroup'
import AShopDetailGroupOrders from '@/components/order/aShopDetailGroupOrders'
import AShopDetailRefundGOrders from '@/components/order/aShopDetailRefundGOrders'
import AShopDetailSeckill from '@/components/goods/aShopDetailSeckill'
import AShopDetailSeckillOrders from '@/components/order/aShopDetailSeckillOrders'
import { queryShopsByAdmin } from '@/api/shop/shopApi'

export default {
  name: 'AShopData',
  components: {
    AdminShop,
    AShopDetailProduct,
    AShopDetailCategory,
    AShopDetailHouse,
    AShopDetailServ,
    AShopDetailInstock,
    AShopDetailOutstock,
    AShopDetailVip,
    AShopDetailOrder,
    AShopDetailRefundOrder,
    AShopDetailGroup,
    AShopDetailGroupOrders,
    AShopDetailRefundGOrders,
    AShopDetailSeckill,
    AShopDetailSeckillOrders
  },
  data() {
    return {
      aShopDataInfo: {
        shopId: '',
        shopName: '',
        shopTypeName: '',
        storeName: '',
        storeAddress: '',
        returnLink: '',
        stateName: '',
        createTime: '',
        _currentTab: 'aShopDetailProduct',
          shopTypeCate: '1'
      }
    }
  },
  created() {
    this.initShop()
  },
  methods: {
    initShop() {
      this.$emit('initShop', (shop) => {
        this.aShopDataInfo.shopId = shop.shopId
        this.loadShopDetail()
      })
    },
    loadShopDetail() {
      if (!this.aShopDataInfo.shopId) {
        return
      }

      queryShopsByAdmin({ shopId: this.aShopDataInfo.shopId, page: 1, row: 1 }).then(response => {
        Object.assign(this.aShopDataInfo, response.data[0])
        this.changeTab(this.aShopDataInfo._currentTab)
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    handleShopChange(shop) {
      this.aShopDataInfo.shopId = shop.shopId
      this.loadShopDetail()
      this.changeTab(this.aShopDataInfo._currentTab)
    },
    changeTab(tab) {
      this.aShopDataInfo._currentTab = tab
      setTimeout(() => {
        this.$refs[tab].open({
          shopId: this.aShopDataInfo.shopId
        })
      }, 500)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}



.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.margin-top {
  margin-top: 15px;
}

.margin-top-sm {
  margin-top: 10px;
}

.col-form-label {
  display: block;
  margin-bottom: 5px;
  color: #606266;
}

.vc-line-primary {
  border-top: 1px solid #409EFF;
}
</style>